var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(240.000000, 538.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M-231-532.9c-0.2,0-0.4-0.1-0.4-0.2l-1-1.7c-0.2-0.3-0.1-0.6,0.1-0.8c0.3-0.1,0.6,0,0.7,0.2l1,1.7 c0.2,0.3,0.1,0.6-0.2,0.7C-230.8-532.9-230.9-532.9-231-532.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1_",
    d: "M-235.4-528.5c-0.1,0-0.2,0-0.3-0.1l-1.7-1c-0.2-0.1-0.3-0.4-0.2-0.7c0.1-0.2,0.4-0.3,0.7-0.2l1.7,1 c0.3,0.2,0.4,0.5,0.2,0.7C-235.1-528.6-235.2-528.5-235.4-528.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2_",
    d: "M-237-522.5h-2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S-236.7-522.5-237-522.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3_",
    d: "M-237.1-515.5c-0.2,0-0.3-0.1-0.4-0.3s-0.1-0.5,0.2-0.7l1.7-1c0.2-0.1,0.5-0.1,0.7,0.2 c0.1,0.2,0.1,0.5-0.2,0.7l-1.7,1C-237-515.5-237-515.5-237.1-515.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4_",
    d: "M-232-510.4c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.3-0.4-0.2-0.7l1-1.7c0.2-0.2,0.5-0.3,0.7-0.1 c0.2,0.1,0.3,0.4,0.2,0.7l-1,1.7C-231.7-510.5-231.8-510.4-232-510.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5_",
    d: "M-225-508.5c-0.3,0-0.5-0.2-0.5-0.5v-2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v2 C-224.5-508.7-224.7-508.5-225-508.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6_",
    d: "M-218-510.4c-0.2,0-0.3-0.1-0.4-0.3l-1-1.7c-0.1-0.2-0.1-0.5,0.2-0.7c0.2-0.1,0.5-0.1,0.7,0.2l1,1.7 c0.1,0.2,0.1,0.5-0.2,0.7C-217.8-510.4-217.9-510.4-218-510.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7_",
    d: "M-212.9-515.5c-0.1,0-0.2,0-0.3-0.1l-1.7-1c-0.2-0.1-0.3-0.4-0.2-0.7c0.1-0.2,0.4-0.3,0.7-0.2l1.7,1 c0.2,0.1,0.3,0.4,0.2,0.7C-212.5-515.6-212.7-515.5-212.9-515.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8_",
    d: "M-210.5-523.1c0-2.4-0.6-4.7-1.7-6.7l-2.1,1.2c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0-0.3-0.1-0.4-0.3 s-0.1-0.5,0.2-0.7l2.1-1.2c-1.2-1.9-2.7-3.4-4.6-4.6l-1.2,2.1c-0.2,0.2-0.3,0.3-0.5,0.3c-0.1,0-0.2,0-0.3-0.1 c-0.2-0.1-0.3-0.4-0.2-0.7l1.2-2.2c-2-1.1-4.3-1.7-6.8-1.7c-0.3,0-0.5,0.2-0.5,0.5v14c0,0.3,0.2,0.5,0.5,0.5h14l0,0 c0.3,0,0.5-0.2,0.5-0.5C-210.5-523.1-210.5-523.1-210.5-523.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.d41b80eb30330b67bc38a3ee3da1cb07.svg";
export { ForwardRef as ReactComponent };